export interface ConfigData {
	payments: {
		defaultAmount: number;
		defaultValidHours: number;
		noShowChargeDays: number;
	}
}

export interface AppConfig extends ConfigData {
	CSRFToken: string;
	requestTimeout: number;
	linkGroupColors: string[];
}


const getConf = (): AppConfig => {
	const configData = JSON.parse(document.getElementById("config").innerHTML);

	return {
		...configData,
		CSRFToken: document
			.querySelector(`meta[name="csrf-token"]`)
			.getAttribute("content"),
		requestTimeout: 15000,
		linkGroupColors: [
			"#e6194b",
			"#3cb44b",
			"#ffe119",
			"#4363d8",
			"#f58231",
			"#911eb4",
			"#46f0f0",
			"#f032e6",
			"#bcf60c",
			"#fabebe",
			"#008080",
			"#e6beff",
			"#9a6324",
			"#fffac8",
			"#800000",
			"#aaffc3",
			"#808000",
			"#ffd8b1",
			"#000075",
			"#808080",
			"#ffffff",
			"#000000"
		]
	};
};

export const conf: AppConfig = getConf();
